<div class="mobile-gate" role="dialog" aria-modal="true">
    <div class="mobile-gate__card">
        <img class="mobile-gate__logo" src="/images/logo.png" alt="RapiDocs" />

        <h1 class="mobile-gate__title">{{ 'core.mobileGate.title' | translate }}</h1>
        <p class="mobile-gate__subtitle">{{ 'core.mobileGate.subtitle' | translate }}</p>

        <div class="mobile-gate__stores">
            @for (store of stores(); track store) {
                @if (store === 'ios') {
                    <a
                        class="mobile-gate__store-btn"
                        [href]="appStoreUrl"
                        target="_blank"
                        rel="noopener"
                    >
                        <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
                            <path
                                fill="currentColor"
                                d="M16.365 1.43c0 1.14-.417 2.2-1.25 3.06-.94.98-2.09 1.55-3.24 1.46-.14-1.13.42-2.3 1.2-3.06.88-.87 2.16-1.5 3.29-1.46zM20.5 17.05c-.55 1.27-.82 1.84-1.53 2.96-.99 1.57-2.39 3.52-4.12 3.53-1.54.02-1.94-1-4.03-.99-2.09.01-2.53 1.01-4.07.99-1.73-.02-3.05-1.78-4.04-3.35C-.06 16.6-.6 11.5 1.47 8.79c1.06-1.39 2.73-2.27 4.31-2.27 1.61 0 2.62 1.02 3.95 1.02 1.29 0 2.08-1.02 3.94-1.02 1.41 0 2.9.77 3.96 2.1-3.48 1.9-2.92 6.86.87 8.43z"
                            />
                        </svg>
                        <span class="mobile-gate__store-text">
                            <span class="mobile-gate__store-caption">{{ 'core.mobileGate.iosCaption' | translate }}</span>
                            <span class="mobile-gate__store-name">App Store</span>
                        </span>
                    </a>
                } @else {
                    <a
                        class="mobile-gate__store-btn"
                        [href]="playStoreUrl"
                        target="_blank"
                        rel="noopener"
                    >
                        <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
                            <path fill="#00d0ff" d="M3.6 1.9 13.3 12 3.6 22.1c-.4-.2-.7-.6-.7-1.2V3.1c0-.6.3-1 .7-1.2z" />
                            <path fill="#00f076" d="M16.7 8.6 5.3 2c-.2-.1-.4-.2-.6-.2L14.9 12l1.8-3.4z" />
                            <path fill="#ff3a44" d="M14.9 12 4.7 22.2c.2 0 .4-.1.6-.2l11.4-6.6L14.9 12z" />
                            <path fill="#ffc900" d="m16.7 8.6-1.8 3.4 1.8 3.4 3.9-2.3c.8-.5.8-1.7 0-2.2l-3.9-2.3z" />
                        </svg>
                        <span class="mobile-gate__store-text">
                            <span class="mobile-gate__store-caption">{{ 'core.mobileGate.androidCaption' | translate }}</span>
                            <span class="mobile-gate__store-name">Google Play</span>
                        </span>
                    </a>
                }
            }
        </div>

        <p class="mobile-gate__footnote">{{ 'core.mobileGate.footnote' | translate }}</p>
    </div>
</div>
